var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading circle position"},[_c('div',{staticClass:"rectangle"},[_c('svg',{attrs:{"x":"0px","y":"0px","viewBox":"0 0 150 150"}},[_c('circle',{staticClass:"loading-inner",attrs:{"cx":"75","cy":"75","r":"60"}})]),_c('p',{staticClass:"desc"},[_vm._t("default",function(){return [_vm._v("Loading…")]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }